import { liteClient as algoliasearch } from 'algoliasearch/lite'

if (!process.env.GATSBY_ALGOLIA_APP_ID || !process.env.GATSBY_ALGOLIA_SEARCH_API_KEY) {
  throw new Error('Algolia credentials are not set in the environment variables.')
}

const ALGOLIA_APP_ID = process.env.GATSBY_ALGOLIA_APP_ID
const ALGOLIA_SEARCH_KEY = process.env.GATSBY_ALGOLIA_SEARCH_API_KEY

const algoliaClient = algoliasearch(ALGOLIA_APP_ID, ALGOLIA_SEARCH_KEY)

// Search client override search to return empty results when there is no query
export const searchClient = {
  ...algoliaClient,
  search(requests) {
    if (requests.every(({ params }) => !params.query)) {
      return Promise.resolve({
        results: requests.map(() => ({
          hits: [],
          nbHits: 0,
          nbPages: 0,
          page: 0,
          processingTimeMS: 0,
        })),
      })
    }

    return algoliaClient.search(requests)
  },
}

export default algoliaClient
